import { BYDESIGN_PRODUCT_QUERY } from 'src/graphql/queries/external/GetBydesignProduct'
import { useQuery } from '@apollo/client'

export const useBydesignProduct = (variables: {
  productId: string
  sponsorId: string
}) => {
  return useQuery<{ getProductItem: any }>(BYDESIGN_PRODUCT_QUERY, {
    variables,
  })
}
